import SVG from './image.svg';
import { face } from '~/notations';

export default {
  SVG,
  algorithm: [
    [
      face.r.one,
      face.u.pri,
      face.r.one,
    ],
    face.f.two,
    [
      face.r.pri,
      face.u.one,
      face.r.pri,
    ],
  ],
  name: 'U & D Diagonals',
};
